// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"467":"1b2bdb8f902735967e95","804":"2daddbe5390fe527ea5d"}[chunkId] + ".css";
};